import { getAvailableRoles, getCurrentRole } from "../utils/roleSwitcher";
import { LOGISTICS_DASHBOARD_MODULE_ROUTES } from "./logisticsDashboardModuleUi";

export function isLogisticsRoleSectionVisible(currentRole = getCurrentRole()) {
  if (currentRole == null) return true;
  return String(currentRole.id) === "logistics";
}

export const LOGISTICS_DASHBOARD_MODULES = [
  {
    key: "overview",
    label: "Overview",
    to: "/dashboard/logistics",
    pathPrefixes: ["/dashboard/logistics"],
  },
  {
    key: "rfqs",
    label: "RFQs",
    to: LOGISTICS_DASHBOARD_MODULE_ROUTES.rfqs,
    pathPrefixes: ["/dashboard/logistics/module/rfqs", "/dashboard/logistics/rfqs"],
  },
  {
    key: "quotations",
    label: "Quotations",
    to: LOGISTICS_DASHBOARD_MODULE_ROUTES.quotations,
    pathPrefixes: ["/dashboard/logistics/module/quotations"],
  },
  {
    key: "contracts",
    label: "Contracts",
    to: LOGISTICS_DASHBOARD_MODULE_ROUTES.contracts,
    pathPrefixes: ["/dashboard/logistics/module/contracts"],
  },
  {
    key: "deliveries",
    label: "Active Deliveries",
    to: LOGISTICS_DASHBOARD_MODULE_ROUTES.deliveries,
    pathPrefixes: ["/dashboard/logistics/module/deliveries"],
  },
  {
    key: "invoices",
    label: "Invoices",
    to: LOGISTICS_DASHBOARD_MODULE_ROUTES.invoices,
    pathPrefixes: ["/dashboard/logistics/module/invoices"],
  },
  {
    key: "performance",
    label: "Performance",
    to: LOGISTICS_DASHBOARD_MODULE_ROUTES.performance,
    pathPrefixes: ["/dashboard/logistics/module/performance"],
  },
];

export const LOGISTICS_DASHBOARD_SUB_TABS = {
  rfqs: [{ key: "inbox", label: "RFQ inbox", to: "/dashboard/logistics/rfqs" }],
  quotations: [{ key: "quotes", label: "My quotations", to: "/dashboard/logistics/rfqs" }],
  deliveries: [{ key: "active", label: "Active deliveries", to: "/dashboard/logistics/rfqs" }],
  invoices: [{ key: "generate", label: "Generate invoice", to: "/dashboard/logistics/rfqs" }],
};

export function buildLogisticsDashboardNavContext(currentRole = getCurrentRole()) {
  const roles = getAvailableRoles();
  const hasLogisticsRole = roles.some((r) => String(r.id) === "logistics");
  const canAccessLogisticsDashboard =
    hasLogisticsRole && isLogisticsRoleSectionVisible(currentRole);

  return {
    roles,
    currentRole,
    hasLogisticsRole,
    canAccessLogisticsDashboard,
  };
}

export function getVisibleLogisticsDashboardModules(ctx) {
  if (!ctx.canAccessLogisticsDashboard) return [];
  return LOGISTICS_DASHBOARD_MODULES;
}

export function getVisibleLogisticsDashboardModuleKeys(ctx) {
  return getVisibleLogisticsDashboardModules(ctx).map((m) => m.key);
}

export function getVisibleLogisticsDashboardSubTabs(moduleKey) {
  return LOGISTICS_DASHBOARD_SUB_TABS[moduleKey] || [];
}

function pathMatchesModule(path, mod) {
  if (mod.key === "overview") {
    return path === "/dashboard/logistics" || path === "/dashboard/logistics/";
  }
  const prefixes = [mod.to, ...(mod.pathPrefixes || [])];
  return prefixes.some((prefix) => {
    if (mod.key === "rfqs" && path.startsWith("/dashboard/logistics/rfqs/")) {
      return false;
    }
    return path === prefix || path.startsWith(`${prefix}/`);
  });
}

export function resolveActiveLogisticsDashboardModule(pathname, modules) {
  const path = pathname || "";
  let best = modules.find((m) => m.key === "overview");
  let bestLen = 0;

  for (const mod of modules) {
    if (mod.key === "overview") continue;
    if (pathMatchesModule(path, mod)) {
      const prefixes = [mod.to, ...(mod.pathPrefixes || [])];
      const bestPrefix = prefixes
        .filter((prefix) => path === prefix || path.startsWith(`${prefix}/`))
        .sort((a, b) => b.length - a.length)[0];
      const len = bestPrefix?.length || 0;
      if (len >= bestLen) {
        best = mod;
        bestLen = len;
      }
    }
  }

  if (path === "/dashboard/logistics" || path === "/dashboard/logistics/") {
    return modules.find((m) => m.key === "overview") || best;
  }

  return best || modules[0];
}

export function isSubTabActive(pathname, tab) {
  const path = pathname || "";
  return path === tab.to || path.startsWith(`${tab.to}/`);
}
